/*
 * @Author: jsZhao
 * @Date: 2017-12-27 10:54:30
 * @Last Modified by: aLeng
 * @Last Modified time: 2018-06-21 10:48:33
 */

// 转化为浮点
const toFloat = value => {
  if(!value) value = 0;
  return Number(value).toFixed(2);
}


const compareTime = (data) => {
  let weekObj = computedPreDays();
  // console.log('compareTime', weekObj.weekend, weekObj.fullTime);
  let line = {
    lineData: [],
    week: [],
  }
  let bar = {
    barData: [],
    week: [],
  }

  let arr = data;
  // console.log('compareTime',arr);
  weekObj.fullTime.forEach(item => {
    arr.forEach(arrItem => {
      if (item.weeks === arrItem.weeks) {
        item.count = arrItem.count;
        item.sum = arrItem.sum;
      }
    })
    line.lineData.push(item.count);
    bar.barData.push(item.sum)
  })
  // console.log('new fullTime',weekObj.fullTime);

    line.week = weekObj.weekend;
    bar.week = weekObj.weekend;

    return {
      line,
      bar
    }

}

// 距今前七天
const computedPreDays = () => {
  let myDate = new Date(); //获取当前时间
  let year = myDate.getFullYear();
  // console.log('year', year)
  let month = myDate.getMonth() + 1;
  let date = myDate.getDate() - 7;
  let week = [];
  let lineData = [];
  let barData = [];
  let weekend = []; //月-日
  let fullTime = []; //总数据
  let num = Math.abs(date); //上个月还剩几天
  // console.log('初始', month, date);

  if (date <= 0) {
    let preMonth = month - 1; //获取上个月
    /*这是当月为1月份,跨年 */
    if (preMonth < 1) {
      // console.log('premonth<1', preMonth);
      preMonth = 11;
      /*跨年，上年12月有多少天*/
      myDate.setMonth(preMonth); //设置上一个与有多少天
      myDate.setDate(0);
      let totelDays = myDate.getDate(); //获取上个月多少天
      let newdate = '';
      date = date + totelDays + 1; //获取从上个月哪天开始
      /* 获取上年上个月日期 */
      for (let i = 0; i <= num; i++) {
        newdate = date + i;
        let singleData = {
          weeks: '',
          count: 0,
          sum: 0
        }
        let newString = parseInt(preMonth + 1) + '-' + newdate;
        singleData.weeks = parseInt(year - 1) + '-' + parseInt(preMonth + 1) + '-' + newdate;
        weekend.push(newString); //月+日
        fullTime.push(singleData); //年+月+日
        newdate = '';
      }
      /* 今年，本月日期 */
      for (let j = 0; j < 6 - num; j++) {
        newdate = 1 + j;
        let newString = month + '-' + newdate;
        let singleData = {
          weeks: '',
          count: 0,
          sum: 0
        }
        singleData.weeks = year + '-' + month + '-' + newdate;
        weekend.push(newString); //月+日
        fullTime.push(singleData); //年+月+日
        newdate = '';
      }
      // console.log('不在一年内-----不在一个月的一周', fullTime);
    } else {
      // console.log('premonth', preMonth);
      /*在本年内，跨月*/
      myDate.setMonth(preMonth); //设置上一个与有多少天
      myDate.setDate(0);
      let totelDays = myDate.getDate(); //获取上个月多少天
      let newdate = '';
      if (preMonth == 2) {
        totelDays = 28;
        if (year % 4 == 0 && year % 100 !== 0 || year % 400 == 0) {
          totelDays = 29;
        }
      }
      date = date + totelDays; //获取从上个月哪天开始
      // console.log('从哪天开始', date);
      // console.log('上个月多少天', totelDays);
      /*获取上个月的日期 */
      for (let i = 0; i <= num; i++) {
        newdate = date + i;
        let singleData = {
          weeks: '',
          count: 0,
          sum: 0
        }
        let newString = preMonth + '-' + newdate;
        singleData.weeks = year + '-' + preMonth + '-' + newdate;
        weekend.push(newString); //月+日
        fullTime.push(singleData); //年+月+日
        newdate = '';
      }
      /*获本个个月的日期 */
      for (let j = 0; j < 6 - num; j++) {
        newdate = 1 + j;
        let newString = month + '-' + newdate;
        let singleData = {
          weeks: '',
          count: 0,
          sum: 0
        }
        singleData.weeks = year + '-' + month + '-' + newdate;
        weekend.push(newString); //月+日
        fullTime.push(singleData); //年+月+日
        newdate = '';
      }
      // console.log('本年内-----不在一个月的一周', fullTime);
    }
  } else {
    for (let i = 0; i < 7; i++) {
      let newdate = date + i;
      let singleData = {
        weeks: '',
        count: 0,
        sum: 0
      }
      let newString = month + '-' + newdate;
      singleData.weeks = year + '-' + month + '-' + newdate;
      weekend.push(newString);
      fullTime.push(singleData);
    }
    // console.log('在一个月一周', fullTime);
  }

  return {
    weekend,
    fullTime
  }
}

//截取日期
const subTime = (data)=>{
  let arr =[];
  data.forEach(item => {
    let newItem = item.slice(5);
    arr.push(newItem);
  });
  return arr;
}


export {
  toFloat,
  compareTime,
  subTime,
}



// WEBPACK FOOTER //
// ./src/utils/index.js